import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AppVersionService {
  //Purpose creates a version key that compares current running code
  //Reloads site if keys don't match
  //Limits reloads to one time so it doesn't do it inifinitely
  //Skips staging tests
  private readonly storageKey = 'app-version';

  async initialize(): Promise<boolean> {
    if (environment.staging) return true;
    try {
      const response = await fetch(`/version.txt?t=${Date.now()}`, {
        cache: 'no-store',
      });

      // If version.txt isn't available, don't prevent the app from loading.
      if (!response.ok) {
        return true;
      }

      const serverVersion = (await response.text()).trim();

      if (!serverVersion) {
        return true;
      }

      const currentVersion = sessionStorage.getItem(this.storageKey);

      // First load for this browser session.
      if (!currentVersion) {
        sessionStorage.setItem(this.storageKey, serverVersion);
        return true;
      }

      // Existing app is running an older version.
      if (currentVersion !== serverVersion) {
        sessionStorage.setItem(this.storageKey, serverVersion);
        window.location.reload();

        return false;
      }

      return true;
    } catch (error) {
      console.warn('Unable to initialize app version', error);
      return true;
    }
  }

  async checkForUpdate(): Promise<void> {
    const currentVersion = sessionStorage.getItem(this.storageKey);

    if (!currentVersion) return;

    //file is in src folder. Angular grabs it on the build using angular.json file assets object
    try {
      const response = await fetch(`/version.txt?t=${Date.now()}`, {
        cache: 'no-store',
      });

      if (!response.ok) return;

      const serverVersion = (await response.text()).trim();

      if (serverVersion && serverVersion !== currentVersion) {
        sessionStorage.setItem(this.storageKey, serverVersion);
        window.location.reload();
      }
    } catch (error) {
      console.warn('Unable to check application version', error);
    }
  }
}
